export default {
  primary: {
    white: {
      5: "rgba(255, 255, 255, 0.05)",
      10: "rgba(255, 255, 255, 0.1)",
      20: "rgba(255, 255, 255, 0.2)",
      30: "rgba(255, 255, 255, 0.3)",
      40: "rgba(255, 255, 255, 0.4)",
      50: "rgba(255, 255, 255, 0.5)",
      60: "rgba(255, 255, 255, 0.6)",
      70: "rgba(255, 255, 255, 0.7)",
      80: "rgba(255, 255, 255, 0.8)",
      90: "rgba(255, 255, 255, 0.9)",
      100: "rgba(255, 255, 255, 1)",
    },
    green: {
      80: "rgba(17, 182, 123, 0.8)",
      20: "rgba(17, 182, 123, 0.2)",
    },
    red: {
      100: "#FF004D",
      90: "rgba(255, 0, 77, 0.9)",
      70: "rgba(255, 0, 77, 0.7)",
      40: "rgba(255, 0, 77, 0.4)",
    },
    black: {
      3: "rgba(0, 0, 0, 0.03)",
      5: "rgba(0, 0, 0, 0.05)",
      10: "rgba(0, 0, 0, 0.1)",
      20: "rgba(0, 0, 0, 0.2)",
      30: "rgba(0, 0, 0, 0.3)",
      40: "rgba(0, 0, 0, 0.4)",
      50: "rgba(0, 0, 0, 0.5)",
      60: "rgba(0, 0, 0, 0.6)",
      70: "rgba(0, 0, 0, 0.7)",
      80: "rgba(0, 0, 0, 0.8)",
      90: "rgba(0, 0, 0, 0.9)",
      100: "rgba(0, 0, 0, 1)",
    },
    turquoise: {
      90: "rgba(33, 250, 237, 0.9)",
      100: "rgba(33, 250, 237, 1)",
    },
    yellow: {
      100: "rgba(255, 230, 7, 1)",
    },
  },
  secondary: {
    yellow: "#F1A91F",
    offYellow: "#BF8619",
    lightBlue: "#D4E9F8",
    lightRed: "#FDF0EF",
  },
  green: {
    highlight: "#31BE69",
  },
  offYellowLight: "#E4DFAA",
  offYellowDark: "#726907",
  landing: {
    green: "#C3D876",
    lightgreen: "#72C0BD",
    palegreen: "#C3D876",
    red: "#FF004D",
    lightblue: "#ADBCDE",
    blue: "#00A1FF",
    deepblue: "#36147E",
    paleyellow: "#E2DCA7",
    yellow: "#F4B641",
    lightyellow: "#e1dcad",
  },
  about: {
    orange: "#FF8A00",
    green: "#C3D876",
    lightgreen: "#72C0BD",
    palegreen: "#C3D876",
    faintgreen: "#E4DFAA",
    red: "#EA3352",
    lightblue: "#ADBCDE",
    blue: "#00A1FF",
    deepblue: "#36147E",
    paleyellow: "#E2DCA7",
    yellow: "#F4B641",
    lightyellow: "#e1dcad",
  },
  stbtc: {
    yellow: "#DEFF80",
    offYellow: "#FAFFE6", // the same color as rgba(222, 255, 128, 0.20), but without transparency
    yellowGradient: "linear-gradient(0deg, #DEFF80 0%, #DEFF80 100%)",
    darkOrange: "#F34900",
  },
}
